export let API_URL, HOST_URL, SOCKET_URL;
if (process.env.NODE_ENV === "production") {
  API_URL = "https://api.numedia.ly/api/v1/";
  HOST_URL = "https://api.numedia.ly/";
} else {
  API_URL = "http://localhost:5000/api/v1/";
  HOST_URL = "http://localhost:5000/";
  SOCKET_URL = "http://localhost:5005/";
}
